import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { bemGenerator } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import actions from './actions';

import './confirm.scss';

const styles = bemGenerator('pj-dialog', [
  'content',
  'title',
  'body',
  'footer',
]);

const ConfirmDialog = ({
  canSave,
  onCancel,
  onConfirm,
  hideModal,
  confirmColor,
  cancelColor,
  ...props
}) => {
  const { t } = useContext(AppContext);
  return (
    <div>
      <div className={styles.content}>
        {props.title && (
          <div className={styles.title}>
            <h2>{props.title}</h2>
          </div>
        )}
        <div className={styles.body}>{props.children}</div>
        <div className={styles.footer}>
          {props.showCancel && (
            <Button onClick={onCancel} color={cancelColor} variant="outlined">
              {props.cancelLabel || t('common', 'button.cancel')}
            </Button>
          )}
          <Button
            wide
            outlined={false}
            onClick={onConfirm}
            color={confirmColor}
          >
            {props.confirmLabel || t('common', 'button.ok')}
          </Button>
        </div>
      </div>
    </div>
  );
};

const { func, string, bool, node, number } = PropTypes;

ConfirmDialog.propTypes = {
  hideModal: func.isRequired,
  onConfirm: func,
  onCancel: func,
  children: node,
  width: number,
  id: string,
  isOpen: bool,
  title: string,
  showCancel: bool,
  confirmLabel: string,
  confirmColor: string,
  cancelLabel: string,
  cancelColor: string,
  canSave: bool,
};

ConfirmDialog.defaultProps = {
  onConfirm: undefined,
  onCancel: undefined,
  children: null,
  width: 400,
  id: undefined,
  isOpen: false,
  title: undefined,
  showCancel: false,
  confirmLabel: undefined,
  confirmColor: 'primary',
  cancelLabel: undefined,
  cancelColor: 'secondary',
  canSave: false,
};

export default connect(null, actions)(memo(ConfirmDialog));
